import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { List, ListSubheader } from "@mui/material";
import { useTranslation } from "react-i18next";

import { useScenarios } from "src/hooks/useScenarios";
import { useCase } from "src/hooks/useCase";

import { ScenarioListItem } from "./ScenarioListItem";
import { CopyStatus } from "src/types";
import styled from "styled-components";

interface Props {
  className?: string;
}

export function ScenarioList(props: Props) {
  const { t } = useTranslation();
  const params = useParams<{ caseId: string }>();
  const { data: acase } = useCase(params.caseId);
  const [refetchInterval, setRefetchInterval] = useState<false | number>(false);
  const { data: scenarios } = useScenarios(params.caseId, refetchInterval);

  useEffect(updateRefreshInterval, [scenarios]);

  function updateRefreshInterval() {
    const result = scenarios?.find((scenario) => scenario.copyStatus === CopyStatus.COPYING);

    // if any scenario is in 'COPYING' status, increase refetch interval
    if (result) return setRefetchInterval(1000);
    // else
    return setRefetchInterval(false);
  }

  return render();

  function render() {
    if (!acase || !scenarios) return null;

    return (
      <StyledList
        className={props.className}
        subheader={
          <ListSubheader className="list-sub-header" component="div">
            {t("label.scenario")}
          </ListSubheader>
        }
      >
        {scenarios.map((scenario) => (
          <ScenarioListItem key={scenario.id} case={acase} scenario={scenario} />
        ))}
      </StyledList>
    );
  }
}

const StyledList = styled(List).attrs({ component: "nav" })`
  .list-sub-header {
    padding-left: ${({ theme }) => theme.spacing(5)};
  }
`;
